export const CHANGE_PASSWORD_TITLE = "CHANGE_PASSWORD_TITLE";
export const CHANGE_PASSWORD_DESCRIPTION = "CHANGE_PASSWORD_DESCRIPTION";
export const CHANGE_PASSWORD_BAYER_TEXT = "CHANGE_PASSWORD_BAYER_TEXT";
export const PASSWORD_LABEL = "PASSWORD_LABEL";
export const PASSWORD_CONFIRM_LABEL = "PASSWORD_CONFIRM_LABEL";
export const PASSWORD_BUTTON_TEXT = "PASSWORD_BUTTON_TEXT";
export const PASSWORD_ERROR_TEXT = "PASSWORD_ERROR_TEXT";
export const PASSWORD_ERROR_TEXT_RULESET_PASSWORD_MUST_CONTAIN =
  "PASSWORD_ERROR_TEXT_RULESET_PASSWORD_MUST_CONTAIN";
export const PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_NUMBER =
  "PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_NUMBER";
export const PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_CAPITAL_LETTER =
  "PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_CAPITAL_LETTER";
export const PASSWORD_ERROR_TEXT_RULE_MINIMUM_PASSWORD_LENGTH =
  "PASSWORD_ERROR_TEXT_RULE_MINIMUM_PASSWORD_LENGTH";
export const PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_LOWERCASE_LETTER =
  "PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_LOWERCASE_LETTER";
export const PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_SPECIAL_CHARACTERS =
  "PASSWORD_ERROR_TEXT_RULE_MINIMUM_OF_X_SPECIAL_CHARACTERS";
export const PASSWORD_ERROR_TEXT_RULESET_PASSWORD_MAY_NOT_CONTAIN =
  "PASSWORD_ERROR_TEXT_RULESET_PASSWORD_MAY_NOT_CONTAIN";
export const PASSWORD_ERROR_TEXT_RULE_SEQUENCES_OF_X_OR_MORE_REPEATED_CHARACTERS =
  "PASSWORD_ERROR_TEXT_RULE_SEQUENCES_OF_X_OR_MORE_REPEATED_CHARACTERS";
export const PASSWORD_DIFF = "PASSWORD_DIFF";
export const PASSWORD_CHANGE_SUCCESS = "PASSWORD_CHANGE_SUCCESS";
export const PASSWORD_CHANGE_ERROR = "PASSWORD_CHANGE_ERROR";
export const PASSWORD_CHANGE_SUCCESS_DESCRIPTION =
  "PASSWORD_CHANGE_SUCCESS_DESCRIPTION";
export const PASSWORD_CHANGE_ERROR_DESCRIPTION =
  "PASSWORD_CHANGE_ERROR_DESCRIPTION";



// WEBPACK FOOTER //
// ./src/i18n/constants.js